import React from 'react';
import { StyledTable, Caption } from './TableContainer.styled';
import { ComponentProps, GroupComponent } from './TableContainer.types';
import TableBody from '../TableBodyContainer/TableBodyContainer';
import TableHead from '../TableHeadContainer/TableHeadContainer';
import TableRow from '../TableRowContainer/TableRowContainer';
import TableCell from '../TableDataContainer/TableDataContainer';
import HeadCell from '../TableHeadDataContainer/TableHeadDataContainer';

const TableContainer: React.FC<ComponentProps> & GroupComponent = ({ children, caption, ...props }: ComponentProps) => (
  <StyledTable borderVariant="rectangle" {...props}>
    {caption && <Caption>{caption}</Caption>}
    {children}
  </StyledTable>
);

TableContainer.Body = TableBody;
TableContainer.Head = TableHead;
TableContainer.HeadCell = HeadCell;
TableContainer.Cell = TableCell;
TableContainer.Row = TableRow;

export default TableContainer;
